import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion, Variants } from 'framer-motion';
import { cn } from '../lib/utils';
interface HyperTextProps {
  text: string;
  duration?: number;
  framerProps?: Variants;
  className?: string;
  animateOnLoad?: boolean;
}
const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const getRandomInt = (max: number) => Math.floor(Math.random() * max);
export function HyperText({
  text,
  duration = 800,
  framerProps = {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 3
    }
  },
  className,
  animateOnLoad = true
}: HyperTextProps) {
  const [displayText, setDisplayText] = useState(text.split(''));
  const [trigger, setTrigger] = useState(false);
  const interations = useRef(0);
  const isFirstRender = useRef(true);
  const triggerAnimation = () => {
    interations.current = 0;
    setTrigger(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (!animateOnLoad && isFirstRender.current) {
        clearInterval(interval);
        isFirstRender.current = false;
        return;
      }
      if (interations.current < text.length) {
        setDisplayText(t => t.map((l, i) => l === ' ' ? l : i <= interations.current ? text[i] : alphabets[getRandomInt(26)]));
        interations.current = interations.current + 0.1;
      } else {
        setTrigger(false);
        clearInterval(interval);
      }
    }, duration / (text.length * 10));
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [text, duration, trigger, animateOnLoad]);
  return <div className="flex scale-100 cursor-default overflow-hidden py-1 justify-center" onMouseEnter={triggerAnimation} data-id="element-110">
      <AnimatePresence mode="wait" data-id="element-111">
        <div className="flex flex-nowrap whitespace-nowrap" data-id="element-112">
          {displayText.map((letter, i) => <motion.span key={i} className={cn('font-mono font-bold text-2xl sm:text-3xl md:text-4xl tracking-wide', letter === ' ' ? 'w-1.5 sm:w-3 md:w-4' : '', className)} {...framerProps} data-id="element-113">
              {letter.toUpperCase()}
            </motion.span>)}
        </div>
      </AnimatePresence>
    </div>;
}